import React, { useState } from 'react';
import { authFetch, API } from '../api';
import PinPad from '../pp2/PinPad';
import TabletTrip from './TabletTrip';
import { TripView } from './inboundApi';

// "Replenish" from the inbound's own page on a cart tablet (Fernando 1.11: he opened inbound 11962 on the tablet and
// found no way to start). The PIN → the same accept as the tablet's home screen (a new trip of this inbound, or the
// trip already on this cart) → the trip, full screen. -- Claude, 2026-11-01

const T = {
  en: { pin: (w: string) => `Inbound ${w} — enter your PIN`, cancel: 'Cancel' },
  et: { pin: (w: string) => `Sissetulek ${w} — sisesta oma PIN`, cancel: 'Tühista' },
  ru: { pin: (w: string) => `Поставка ${w} — введите PIN`, cancel: 'Отмена' },
};

export default function TabletStart({ inboundId, wgr, lang, onExit }: {
  inboundId: number; wgr: string; lang?: string | null;
  /** the trip is over, paused, or the PIN was cancelled */
  onExit: () => void;
}) {
  const tx = T[(lang as 'en' | 'et' | 'ru')] || T.en;
  const [trip, setTrip] = useState<TripView | null>(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const forInbound = inboundId;

  const accept = async (pin: string) => {
    setBusy(true); setErr('');
    try {
      const r = await authFetch(`${API}/inbound/tablet/accept`, { method: 'POST', body: JSON.stringify({ pin, inbound_id: forInbound }) });
      const j = await r.json().catch(() => ({} as any));
      if (!r.ok) { setErr(typeof j.detail === 'string' ? j.detail : j.detail?.message || `HTTP ${r.status}`); return; }
      setTrip(j);
    } catch { setErr('No connection to the WMS'); } finally { setBusy(false); }
  };

  if (trip) {
    return <TabletTrip view={trip} onView={setTrip} onPaused={onExit} onClose={onExit} />;
  }
  return (
    <div className="fixed inset-0 z-50 bg-[#e5e7eb] text-[#111111] overflow-y-auto flex items-start justify-center px-5 py-8">
      <PinPad title={tx.pin(wgr)} error={err} busy={busy} onSubmit={accept} cancelLabel={tx.cancel} onCancel={onExit} />
    </div>
  );
}
